//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import { rutFilter } from 'vue-dni'
import { FormInput } from '@/components/Form'

export default {
  components: {
    FormInput,
    ValidationObserver,
  },
  props: {
    requiredFields: {
      type: Array,
      default: () => ['name', 'email'],
    },
  },
  data() {
    return {
      form: {
        names: '',
        lastnames: '',
        email: '',
        repeatEmail: '',
        identification_number: '',
        phone: '',
      },
    }
  },

  watch: {
    form: {
      handler() {
        this.form.identification_number = rutFilter(
          this.form.identification_number
        )
        this.handleChangeForm()
      },
      deep: true,
    },
  },
  methods: {
    async handleChangeForm() {
      const isValid = await this.$refs.newUserFormObserver.validate()
      this.$emit('valid-form', isValid)
      this.$emit('change-form', this.form)
    },
    formatRules(field, defaultRules) {
      const isRequired = this.requiredFields.includes(field)
      if (!defaultRules) {
        return isRequired ? 'required' : ''
      }
      return isRequired ? `${defaultRules}|required` : defaultRules
    },
  },
}
